import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import ArrModal from '../../../components/common/arr-modal/ArrModal';
import {Box, Button, Typography} from '@mui/material';
import '../Demo.scss';
import {InfoOutline} from '@mui/icons-material';

const ModalDemo: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <Box className="demo-page modal-demo">
      <h1>Modal</h1>
      <Typography>
        Modal inform users about a task and can contain critical information,
        require decisions, or involve multiple tasks.
      </Typography>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <Box className="button-row">
        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          data-testid="modal-demo-simple-modal-button">
          Simple Modal
        </Button>
        <Button
          variant="contained"
          onClick={() => setShowModal(true)}
          data-testid="modal-demo-modal-button">
          Modal
        </Button>
      </Box>
      <Box>
        <ArrModal
          showModal={open}
          onClose={() => setOpen(false)}
          headerTitle="Header Title"
          title="Title"
          description="Description"
          dataTestId="Header-Title-modal"
          buttons={[
            {
              id: '1',
              label: 'Yes, leave it',
              onClick: () => setOpen(false),
              variant: 'secondary',
              dataTestId: 'leave-it',
            },
            {
              id: '2',
              label: 'Stay here',
              onClick: () => setOpen(false),
              variant: 'primary',
              dataTestId: 'stay-here',
            },
          ]}
        />
        <ArrModal
          showModal={showModal}
          onClose={() => setShowModal(false)}
          headerTitle="Header Title"
          title="Long Title Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. "
          dataTestId="Header-Title-1-modal"
          buttons={[
            {
              id: '1',
              label: 'Yes, leave it',
              onClick: () => setShowModal(false),
              variant: 'secondary',
              dataTestId: 'leave-it-1',
            },
            {
              id: '2',
              label: 'Stay here',
              onClick: () => setShowModal(false),
              variant: 'primary',
              dataTestId: 'stay-here-1',
            },
          ]}
          titleStartIcon={
            <InfoOutline fontSize="small" sx={{color: 'white'}} />
          }
          titleEndIcon={<InfoOutline fontSize="small" sx={{color: 'white'}} />}
        >
          <Box
            sx={{
              mt: 2,
              p: 2,
              borderRadius: 2,
              bgcolor: 'rgba(255,255,255,0.04)',
              fontSize: 14,
              color: 'white',
            }}
          >
            Additional content comes from children.
          </Box>
        </ArrModal>
      </Box>
    </Box>
  );
};

export default ModalDemo;
